import {
  get,
  post
} from '../index'
export default {
  // 版权
  getCopyrightInfo () {
    return get('/card/Admin/getW7Tmp')
  },
  // 是否为微擎版，还是为独立版
  getIsWeiVersion () {
    return get('/agent/admin/isWe7')
  },
  // 退出登录
  userlogout () {
    return get('/agent/admin/unAuth')
  },
  // 获取订阅消息模版列表
  tmpList (querys) {
    return post('/publics/tmpl/AdminTmpl/tmpList', querys)
  },
  // 获取订阅消息模版列表
  tmpLists (querys) {
    return post('/publics/tmpl/AdminTmpl/tmpLists', querys)
  },
  // 自动同步模版ID
  getTmplId (querys) {
    return post('/publics/tmpl/AdminTmpl/getTmplId', querys)
  },
  // 保存订阅消息模版
  tmplUpdate (querys) {
    return post('/publics/tmpl/AdminTmpl/tmplUpdate', querys)
  }
}



// WEBPACK FOOTER //
// ./src/api/modules/base.js